<template>
  <div>
    <div class="member_information clearfix_">
      <div class="member_information_member fl clearfix_">
        <div class="member_pic fl">
          <img :src="memberUser.pic?memberUser.pic:member_pic" alt="">
        </div>
        <div class="member_name fl">
          <div class="member_name_">{{memberUser.name}}</div>
          <div class="member_addres"><router-link tag="a" target="_blank" :to="{name:'address'}">我的收货地址></router-link></div>
        </div>
      </div>
      <div class="fl member_population">
        <div @click="goto(1,5)" class="fl">
          <p class="txt_1">{{memberUser.collectionNum}}</p>
          <p  class="txt_2">我的收藏</p>
        </div>
        <div @click="goto(2,7)" class="fl">
          <p class="txt_1">{{memberUser.tenantNum}}</p>
          <p class="txt_2">我的店铺</p>
        </div>
        <div class="fl">
          <p class="txt_1">0</p>
          <p class="txt_2">最新活动</p>
        </div>
      </div>
    </div>
     <div class="order_aggregate">
      <div class="clearfix_ order_title">
        <p class="fl txt1">我的拼团</p>
        <p class="fr txt2">
          <router-link tag="a" target="_blank" :to="{name:'teamOrder',query: {state:0}}">全部拼团></router-link>
        </p>
      </div>
      <div>
        <ul class="clearfix_ order_item_box">
          <li class="fl order_item" :class="{order_item_active:teamIdx_==index}" v-for="(item,index) in teamOrderList" @click="getTeamOrderMall(index)" :key="index">{{item.title}}</li>
        </ul>
        <div class="order_item_details">
          <div v-show="orderTeamListMall.length" v-for="(item,index) in orderTeamListMall" :key="index" class="order_item_goods clearfix_">
            <div class="clearfix_">
              <div class="fl" style="width:507px;">
              <div style="margin-bottom:10px;" class="clearfix_">
                <div class="fl clearfix_">
                  <div class="order_item_goods_pic fl">
                    <img :src="item.pic?item.pic:timg" alt="">
                  </div>
                  <div class="order_item_goods_name fl">
                    <p class="txt1">{{item.goodsName}} {{item.property1}} {{item.goodsUnitName}}</p>
                    <p class="txt2">¥{{item.price}}</p>
                  </div>
                </div>
              </div>
            </div>
             <div class="fr order_item_goods_num">
              <p>订单：<span>{{item.scode}}</span></p>
              <p v-show="teamIdx_==0">等待分享</p>
              <p v-show="teamIdx_==0"><button><router-link tag="a" target="_blank" :to="{name:'teamOrderDetails',query:{id:item.id}}">立即分享</router-link></button></p>
              <p v-show="teamIdx_==1">查看详情</p>
              <p v-show="teamIdx_==1"><button><router-link tag="a" target="_blank" :to="{name:'teamOrderDetails',query:{id:item.id}}">查看详情</router-link></button></p>
              <p v-show="teamIdx_==2">查看详情</p>
              <p v-show="teamIdx_==2"><button><router-link tag="a" target="_blank" :to="{name:'teamOrderDetails',query:{id:item.id}}">查看详情</router-link></button></p>
            </div> 
            </div>
            <div v-show="Total-1!=0" class="order_More">
              <p>
                <router-link tag="a" target="_blank" :to="{name:'teamOrder',query:{state:item.status}}">查看剩余<span>{{teamTotal-1}}</span>个订单></router-link>
              </p>
            </div>
          </div>
          <div style="line-height:50px;text-align:center;" v-show="!orderTeamListMall.length">暂无该状态订单！</div>
        </div>
      </div>
    </div>  
    <div class="order_aggregate">
      <div class="clearfix_ order_title">
        <p class="fl txt1">我的订单</p>
        <p class="fr txt2">
          <router-link tag="a" target="_blank" :to="{name:'order',query: {state:0}}">全部订单></router-link>
        </p>
      </div>
      <div>
        <ul class="clearfix_ order_item_box">
          <li class="fl order_item" :class="{order_item_active:idx_==index}" v-for="(item,index) in orderList" @click="getOrderMall(index)" :key="index">{{item.title}}</li>
        </ul>
        <div class="order_item_details">
          <div v-show="orderListMall.length" v-for="(item,index) in orderListMall" :key="index" class="order_item_goods clearfix_">
            <div class="clearfix_">
              <div class="fl" style="width:507px;">
              <div style="margin-bottom:10px;" class="clearfix_" v-for="(val,idx) in item.orderItem" :key="idx">
                <div class="fl clearfix_">
                  <div class="order_item_goods_pic fl">
                    <img :src="val.goodsUrl?val.goodsUrl:timg" alt="">
                  </div>
                  <div class="order_item_goods_name fl">
                    <p class="txt1">{{val.goodsName}}</p>
                    <p class="txt2">¥{{val.salesMoney}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="fr order_item_goods_num">
              <p>订单：<span>{{item.order.scode}}</span></p>
              <p v-show="idx_==0">等待付款</p>
              <p v-show="idx_==0"><button><router-link tag="a" target="_blank" :to="{name:'stayPay',query:{id:item.order.outTradeNo,orderId:item.order.id}}">立即付款</router-link></button></p>
              <p v-show="idx_==1">等待收货</p>
              <p v-show="idx_==1"><button><router-link tag="a" target="_blank" :to="{name:'orderDetails',query:{id:item.order.id}}">立即收货</router-link></button></p>
              <p v-show="idx_==2">等待评价</p>
              <p v-show="idx_==2"><button><router-link tag="a" target="_blank" :to="{name:'orderDetails',query:{id:item.order.id}}">立即评价</router-link></button></p>
            </div>
            </div>
            <div v-show="Total-1!=0" class="order_More">
              <p>
                <router-link tag="a" target="_blank" :to="{name:'order',query:{state:item.order.status}}">查看剩余<span>{{Total-1}}</span>个订单></router-link>
              </p>
            </div>
          </div>
          <div style="line-height:50px;text-align:center;" v-show="!orderListMall.length">暂无该状态订单！</div>
        </div>
      </div>
    </div>
    <div class="myAssets">
      <div class="clearfix_ order_title">
        <p class="fl txt1">我的资产</p>
        <p @click="gotoLink('allTenant')" class="fr txt2">全部资产></p>
      </div>
      <div v-for="(item,index) in tenantList" :key="index" class="myAssets_details clearfix_">
        <div class="myAssets_details_logo fl">
          <img :src="item.webPic?item.webPic:timg" alt="">
        </div>
        <div @click="goToMemberBalance(item.memberCardId,item.tenantId)" class="fl myAssets_details_txt">
          余额：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{item.moneyAmount}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <div @click="goToMemberScore(item.memberCardId,item.tenantId)" class="fl myAssets_details_txt">
          积分：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{item.score}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <div @click="goToStoredValueCard(item.memberCardId,item.tenantId)" class="fl myAssets_details_txt">
          储值：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{item.cardRuleNum}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <div @click="goToCoupon(item.tenantId)" class="fl myAssets_details_txt">
          优惠券：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{item.couponNum}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </div>
        <div class="fl myAssets_details_txt">
          礼包：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{item.shoppingNum}}</span>
        </div>
      </div>
    </div>
    <div class="guess_what_you_like">
      <div class="clearfix_ order_title guess_what_you_like_title_">
        <p class="fl txt1">根据浏览，猜你喜欢</p>
        <p class="fr txt2"><span @click="change">换一批 <img class="guess_what_you_like_title_refresh" :src="refresh" alt=""></span></p>
      </div>
      <div class="guess_what_you_like_goods clearfix_">
        <dl v-for="(item,index) in footPrintList" :key="index" class="fl clearfix_">
          <dt class="fl"><img :src="item.pic1?item.pic1:timg" alt=""></dt>
          <dd class="fl">
            <p class="txt1">{{item.goodsAlias?item.goodsAlias:item.goodname}}</p>
            <p class="txt2">
              <span class="txt2_price">¥ {{item.price}}</span>
              <span class="txt2_details" @click="gotoDetails(item.webname,item.goodsId,item.goodname)">查看详情</span>
            </p>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/reset.css'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return {
      member_pic:require('../../assets/img/niu.png'),
      refresh:require('../../assets/img/refresh.png'),
      timg:require('../../assets/img/timg.gif'),
      orderList:[{id:0,title:'待付款',},{id:1,title:'待收货',},{id:2,title:'待评价',}],
      teamOrderList:[{id:0,title:'待分享',},{id:1,title:'已成团',},{id:2,title:'失败团',}],
      tenantList:[],
      idx_:0,
      teamIdx_:0,
      orderListMall:[],
      orderTeamListMall:[],
      memberUser:{},
      Total:0,
      teamTotal:0,
      page:1,
      footPrintList:[]
    }
  },
  mounted:function(){
    var t_=this
    t_.getTenant()
    t_.getOrderMall(0)
    t_.getTeamOrderMall(0)
    t_.getMenber()
    t_.getFootPrint()
  },
  methods:{
    goto:function(type,idx){
      var t_=this
      if(type==1){
				this.$router.push({name:'collections'})
      }else if(type==2){
				this.$router.push({name:'activityList'})
      }
      // let query = this.$router.history.current.query
      // let path = this.$router.history.current.path
      // let newQuery = JSON.parse(JSON.stringify(query))
      // newQuery.listId = idx
			// this.$router.push({ path, query: newQuery })
    },
    goToCoupon:function(tenantId){
      var t_=this
      var href=this.$router.resolve({name:'myCoupon',query:{tenantId:tenantId}})
      return window.open(href.href,'_blank')
    },
    goToStoredValueCard:function(memberCardId,tenantId){
      var t_=this
			var href=this.$router.resolve({name:'storedValueCard',query:{memberCardId:memberCardId,tenantId:tenantId}})
      return window.open(href.href,'_blank')
    },
    goToMemberScore:function(memberCardId,tenantId){
      var t_=this
			var href=this.$router.resolve({name:'memberScore',query:{memberCardId:memberCardId,tenantId:tenantId}})
      return window.open(href.href,'_blank')
    },
    goToMemberBalance:function(memberCardId,tenantId){
      var t_=this
			var href=this.$router.resolve({name:'memberBalance',query:{memberCardId:memberCardId,tenantId:tenantId}})
      return window.open(href.href,'_blank')
    },
    gotoLink:function(link){
			var href=this.$router.resolve({name:link})
      return window.open(href.href,'_blank')
		},
    gotoDetails:function(web,id,name){
      var t_=this
      var url='http://'+web+'/goodsdetails?goodsId='+id
      window.open(url,'_blank')
    },
    getMenber:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2
      })
      axios.post(`${ip}formWorkInterface/memberInfo`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0)t_.memberUser=res.data.data
      })
    },
    getTeamOrderMall:function(idx){
      var t_=this
      t_.teamIdx_=idx
      var data0bj={
        page:1,
        pagesize:1,
        channel:2,
        status:0,
        tamp:localStorage.tamp?localStorage.tamp:''
      }
      if(idx==0)data0bj.status=1
      if(idx==1)data0bj.status=2
      if(idx==2)data0bj.status=3
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}spellGroupInterface/getMallOrderData`,data0bj).then(res =>{
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.orderTeamListMall=res.data.retailSpellGroupOrderItemData
          t_.teamTotal=res.data.total
        }
      })
    },
    getOrderMall:function(idx){
      var t_=this
      t_.idx_=idx
      var data0bj={
        page:1,
        pagesize:1,
        channel:2,
        status:1,
        tamp:localStorage.tamp?localStorage.tamp:''
      }
      if(idx==0)data0bj.status=1
      if(idx==1)data0bj.status=3
      if(idx==2)data0bj.status=4
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/getMallOrderData`,data0bj).then(res =>{
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.orderListMall=res.data.data.Rows
          t_.Total=res.data.data.total
        }
      })
    },
    getTenant:function(){
      var t_=this
      var data0bj=Qs.stringify({
        page:1,
        pagesize:1,
        channel:2,
        status:2,
        tamp:localStorage.tamp?localStorage.tamp:''
      })
      axios.post(`${ip}formWorkInterface/getUserMemberCard`,data0bj).then(res=>{
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code!=0)return
        t_.tenantList=res.data.data.rows
      })
    },
    change:function(){
      var t_=this
      if(t_.page>=t_.lagePage){
        t_.page=1
        t_.getFootPrint()
        return
      }
      t_.page++
      t_.getFootPrint()
    },
    getFootPrint:function(){
      var t_=this
      var data0bj=Qs.stringify({
        page:t_.page,
        pagesize:10,
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:''
      })
      axios.post(`${ip}formWorkInterface/getFootPrint`,data0bj).then(res =>{
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code!=0)return
        t_.footPrintList=res.data.data.rows
        t_.lagePage=res.data.data.last_page
      })
    }
  }
}



</script>

<style>
  .member_information{
    height: 150px;
    background: #fff;
  }
  .member_information_member{
    width: 710px;
    padding-top: 25px;
    padding-left: 20px;
  }
  .member_pic{
    width: 100px;
    height: 100px;
    overflow: hidden;
    border-radius: 50%;
    margin-right: 20px;
  }
  .member_pic img{
    width: 100px;
    height: 100px;
  }
  .member_name{
    padding-top: 20px;
  }
  .member_name_{
    font-size:16px;
    font-weight: 900;
  }
  .member_addres{
    margin-top: 32px;
    cursor: pointer;
  }
  .member_population{
    width: 234px;
    height: 60px;
    padding-top:40px;
  }
  .member_population div{
    width: 33.3%;
    cursor: pointer;
  }
  .member_population div p{
    text-align: center;
  }
  .member_population div .txt_1{
    color:#f70;
    font-size: 16px;
  }
  .member_population div .txt_2{
    margin-top: 35px;
  }
  .order_aggregate{
    margin-top:10px;
    background:#fff;
  }
  .order_title p{
    width: 50%;
    height: 40px;

  }
  .order_title .txt1{
    font-size:16px;
    line-height: 40px;
    color:#666;
    margin-left:20px;
    font-weight: 900;
  }
  .order_title .txt2{
    text-align: right;
    color:#666;
    font-size: 12px;
    padding-right:20px;
    line-height: 40px;
    width: 45%;
    cursor: pointer;
  }
  .order_item_box{
    border: 1px solid #efefef;
    border-left:0;
    border-right: 0;
    height: 40px;
  }
  .order_item{
    width: 155px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-weight: 900;
    border-right: 1px solid #efefef;
    cursor: pointer;
  }
  .order_item_active{
    color:#dd2c3a;
    border-bottom:1px solid #fff;
  }
  .order_item_details{
    padding: 0 20px;
  }
  .order_item_goods{
    padding-top: 16px;
  }
  .order_item_goods_pic{
    width: 60px;
    height: 60px;
    border: 1px solid #efefef;
    padding: 10px;
    margin-right: 25px;
  }
  .order_item_goods_pic img{
    width: 60px;
    height: 60px;
  }
  .order_item_goods_name{
    width: 400px;
    height: 82px;
  }
  .order_item_goods_name .txt1{
    margin-top:6px;
    line-height: 18px;
    color:#666;
    margin-bottom: 15px;
  }
  .order_item_goods_num{
    width: 400px;
  }
  .order_item_goods_num p{
    text-align: right;
    margin-bottom: 12px;
  }
  .order_item_goods_num p button{
    width: 68px;
    height: 22px;
    border: 1px solid #ddd;
    background: #fff;
    cursor: pointer;
  }
  .order_item_goods_num p span{
    color:#333;
  }
  .order_More{
    height: 33px;
    border-top:1px solid #efefef;
    text-align: center;
  }
  .order_More p{
    line-height: 33px;
    cursor: pointer;
  }
  .order_More span{
    color:#f70;
  }
  .myAssets{
    background:#fff;
    margin-top:10px;
  }
  .myAssets_details{
    padding: 20px;
  }
  .myAssets_details_logo{
    width: 200px;
    height: 40px;
    overflow: hidden;
    text-align: center;
  }
  .myAssets_details_logo img{
    height: 40px;
  }
  .myAssets_details span{
    color:#f70;
  }
  .myAssets .myAssets_details_txt{
    width: auto;
    line-height: 40px;
    cursor: pointer;
  }
  .guess_what_you_like{
    background: #fff;
    margin-top: 10px;
  }
  .guess_what_you_like_title_ .txt1{
    font-weight: 100;
  }
  .guess_what_you_like_goods{
    padding: 20px;
  }
  .guess_what_you_like_goods dl{
    width: 50%;
    height: 180px;
    border-bottom: 1px solid #efefef;
    position: relative;
    margin-bottom: 20px;
  }
  .guess_what_you_like_goods dt{
    width: 158px;
    height: 158px;
    border: 1px solid #efefef;
    margin-right: 10px;
  }
  .guess_what_you_like_goods dt img{
    width: 158px;
    height: 158px;
  }
  .guess_what_you_like_goods .txt1{
    line-height: 20px;
    margin-bottom: 20px;
    width: 280px;
  }
  .guess_what_you_like_goods .txt2_price{
    color:#f60;
  }
  .guess_what_you_like_goods .txt2_details{
    position: absolute;
    right: 40px;
    bottom: 30px;
    width: 70px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    border: 1px solid #efefef;
    border-radius: 5px;
    cursor: pointer;
  }
  .guess_what_you_like_title_refresh{
    width: 15px;
    height: 15px;
    margin-top:13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/replace.vue